module.exports = __webpack_public_path__ + "dist/media/ec_comp_icons.af36e18c.svg";